exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reset-form[_v-64bb6125]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-64bb6125&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/ResetForm.vue
// module id = 268
// module chunks = 0